import React, {Fragment} from "react";
import PropTypes from "prop-types";
import Page from "../../../../../components/BaseComponents/Page/Page";
import {FaSolidIcon} from "../../../../../components/FontAwesomeIcons";
import {swalError, swalLoading, swalSuccess} from "../../../../../helpers/SweetAlertWrapper";
import {ModuloHRAPI} from "../../../../../api/ModuloHR/ModuloHRAPI";
import SignaturePadCanvas from "./SignaturePadCanvas";

export default class TimeoffPaySlipSignatureModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            submitting: false,
            padReady: false
        };
        this.signaturePadRef = React.createRef();
        this.signaturePadUrl = "https://cdn.jsdelivr.net/npm/signature_pad@5.1.3/dist/signature_pad.umd.min.js";
    }

    handleClear = _ => {
        const signaturePad = this.signaturePadRef.current;
        if (signaturePad && signaturePad.isReady()) {
            signaturePad.clear();
        }
    }

    handleConfirm = _ => {
        const signaturePad = this.signaturePadRef.current;
        if (!signaturePad || !signaturePad.isReady()) {
            swalError("Firma non disponibile");
            return;
        }

        if (signaturePad.isEmpty()) {
            swalError("Firma vuota");
            return;
        }

        const signatureSvg = signaturePad.toSVG();
        if (!signatureSvg || signatureSvg.indexOf("<svg") === -1) {
            swalError("Firma non valida");
            return;
        }

        if (!this.props.paySlip?.pay_slip_id) {
            swalError("Busta paga non valida");
            return;
        }

        this.setState({submitting: true});
        swalLoading();
        ModuloHRAPI.PaySlips.sign(this.props.paySlip.pay_slip_id, signatureSvg)
            .then(message => {
                swalSuccess(message || "Busta paga firmata");
                this.setState({submitting: false});
                if (this.props.onSigned) {
                    this.props.onSigned();
                }
            })
            .catch(error => {
                this.setState({submitting: false});
                swalError(error || "Non e' stato possibile firmare la busta paga");
            });
    }

    handlePadReady = _ => {
        this.setState({padReady: true});
    }

    handlePadError = error => {
        this.setState({padReady: false});
        swalError(error?.message || "Firma non disponibile");
    }

    render() {
        return (
            <Fragment>
                <Page
                    title={"Firma busta paga"}
                    leftIcon={<FaSolidIcon name={"chevron-left"}/>}
                    onLeftIconClick={this.props.onDismiss}
                    active={this.props.active}
                    content={
                        <div className={"container py-3"}>
                            <div className={"mb-3 __disable-swipe"}>
                                <SignaturePadCanvas
                                    ref={this.signaturePadRef}
                                    scriptUrl={this.signaturePadUrl}
                                    onReady={this.handlePadReady}
                                    onError={this.handlePadError}
                                />
                            </div>
                            <div className={"d-flex flex-wrap"}>
                                <button
                                    type={"button"}
                                    className={"btn btn-outline-secondary mr-2 mb-2"}
                                    onClick={this.handleClear}
                                    disabled={this.state.submitting || !this.state.padReady}
                                >
                                    Cancella firma
                                </button>
                                <button
                                    type={"button"}
                                    className={"btn btn-primary mb-2"}
                                    onClick={this.handleConfirm}
                                    disabled={this.state.submitting || !this.state.padReady}
                                >
                                    Firma e conferma
                                </button>
                            </div>
                        </div>
                    }
                />
            </Fragment>
        );
    }
}

TimeoffPaySlipSignatureModal.propTypes = {
    active: PropTypes.bool,
    onDismiss: PropTypes.func,
    onSigned: PropTypes.func,
    paySlip: PropTypes.object
};
